export const STATISTICS_CATEGORIES = {
  OFFENSIVE: 'offensive',
  DEFENSIVE: 'defensive',
  GOALKEEPING: 'goalkeeping',
};

export const STATISTICS_CATEGORY_LABELS = {
  [STATISTICS_CATEGORIES.OFFENSIVE]: {
    key: 'eventodeportivo_paises_Tab_texto_titulo_Ataques',
    length: 22,
  },
  [STATISTICS_CATEGORIES.DEFENSIVE]: {
    key: 'eventodeportivo_paises_Tab_texto_titulo_Defensas',
    length: 22,
  },
  [STATISTICS_CATEGORIES.GOALKEEPING]: {
    key: 'eventodeportivo_paises_Tab_texto_titulo_Porteros',
    length: 22,
  },
};

export const STATISTICS_LEGEND_KEYS = {
  // Offensive
  G: { key: 'eventodeportivo_siglas_texto_goles' },
  PAG: { key: 'eventodeportivo_siglas_texto_pasesgol' },
  TT: { key: 'eventodeportivo_siglas_texto_tirostotales' },
  TAP: { key: 'eventodeportivo_siglas_texto_tirosporteria' },
  PT: { key: 'eventodeportivo_siglas_texto_pasestotales' },
  RE: { key: 'eventodeportivo_siglas_texto_regatesexito' },
  FR: { key: 'eventodeportivo_siglas_texto_faltasrecibidas' },
  FJ: { key: 'eventodeportivo_siglas_texto_fueradejuego' },
  // Defensive
  I: { key: 'eventodeportivo_siglas_texto_intercepciones' },
  EG: { key: 'eventodeportivo_siglas_texto_entradasganadas' },
  FC: { key: 'eventodeportivo_siglas_texto_faltascometidas' },
  TA: { key: 'eventodeportivo_siglas_texto_tarjetasamarillas' },
  // Goalkeeping
  PP: { key: 'eventodeportivo_siglas_texto_paradasportero' },
  PAC: { key: 'eventodeportivo_siglas_texto_porteriacero' },
};

export const STATISTICS_CODE_KEYS = {
  // Offensive
  G: { key: 'eventodeportivo_siglas_texto_titulo_goles' },
  PAG: { key: 'eventodeportivo_siglas_texto_titulo_pasesgol' },
  TT: { key: 'eventodeportivo_siglas_texto_titulo_tirostotales' },
  PT: { key: 'eventodeportivo_siglas_texto_titulo_pasestotales' },
  TAP: { key: 'eventodeportivo_siglas_texto_titulo_tirosporteria' },
  RE: { key: 'eventodeportivo_siglas_texto_titulo_regatesexito' },
  FR: { key: 'eventodeportivo_siglas_texto_titulo_faltasrecibidas' },
  FJ: { key: 'eventodeportivo_siglas_texto_titulo_fueradejuego' },
  // Defensive
  I: { key: 'eventodeportivo_siglas_texto_titulo_intercepciones' },
  EG: { key: 'eventodeportivo_siglas_texto_titulo_entradasganadas' },
  FC: { key: 'eventodeportivo_siglas_texto_titulo_faltascometidas' },
  TA: { key: 'eventodeportivo_siglas_texto_titulo_tarjetasamarillas' },
  // Goalkeeping
  PP: { key: 'eventodeportivo_siglas_texto_titulo_paradasportero' },
  PAC: { key: 'eventodeportivo_siglas_texto_titulo_porteriacero' },
};

export const STATISTICS_FULL_STATS_LABEL = {
  key: 'eventodeportivo_paises_texto_titulo_verestadistica',
  length: 22,
};

export const STATISTICS_LEGENDS_BY_CATEGORY = {
  [STATISTICS_CATEGORIES.OFFENSIVE]: [
    'G',
    'PAG',
    'TT',
    'TAP',
    'PT',
    'RE',
    'FR',
    'FJ',
  ],
  [STATISTICS_CATEGORIES.DEFENSIVE]: ['I', 'EG', 'FC', 'TA'],
  [STATISTICS_CATEGORIES.GOALKEEPING]: ['PP', 'PAC'],
};
